import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { container } from '@infrastructure/di/container';
import { QUERY_KEYS } from '@shared/constants';
import type { VariableInput } from '@core/repositories/CollectionRepository';

export const useGlobalVariables = (workspaceId: string | undefined) => {
  return useQuery({
    queryKey: QUERY_KEYS.globalVariables(workspaceId ?? ''),
    queryFn: () => container.globalVariables.list(workspaceId as string),
    enabled: Boolean(workspaceId),
  });
};

export const useSyncGlobalVariables = (workspaceId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: VariableInput[]) =>
      container.globalVariables.sync(workspaceId, variables),
    onSuccess: (variables) => {
      queryClient.setQueryData(QUERY_KEYS.globalVariables(workspaceId), variables);
    },
  });
};
